import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess, clearUserPermissions } from "./actions"



import { postAppLogin } from "../../../helpers/api_helper"


function* loginUser({ payload: { user, navigate } }) {
  try {
    // Use app-specific login endpoint for per-app user authentication
    const response = yield call(postAppLogin, {
      email: user.email,
      password: user.password,
    });

    // Save the response in localStorage
    localStorage.setItem("authUser", JSON.stringify(response));

    if (response.error) {
      yield put(apiError(response.error.message));
    } else {
      yield put(loginSuccess(response));

      // Retrieve the updated user object from localStorage
      const loggedInUser = JSON.parse(localStorage.getItem("authUser"));

      if (loggedInUser) {
        const role = (loggedInUser.role || "").toLowerCase().trim();
        const permissions = loggedInUser.permissions || {};
        const permType = permissions.type;
        console.log("[Login] User:", loggedInUser.email, "Role:", loggedInUser.role, "permType:", permType);

        // Permission-based routing (B2B / Retail / Admin)
        if (permType === "b2b") {
          navigate("/quote");
        } else if (permType === "retail") {
          navigate("/orders");
        } else if (permissions.all === true) {
          navigate("/orders");
        } else if (role === "user" || role === "logistirio" || role === "admin") {
          navigate("/orders");
        } else if (role === "production") {
          navigate("/tasks");
        } else if (role === "operations") {
          navigate("/operations");
        } else if (role === "driver") {
          if (loggedInUser.id) {
            navigate(`/driver/${loggedInUser.id}`);
          } else {
            console.error("No user ID found for driver:", loggedInUser.email);
            yield put(apiError("Driver account not properly configured. Please contact administrator."));
          }
        } else if (role === "store") {
          if (loggedInUser.id) {
            navigate(`/store/${loggedInUser.id}`);
          } else {
            console.error("No user ID found for store user:", loggedInUser.email);
            yield put(apiError("Store account not properly configured. Please contact administrator."));
          }
        } else if (role === "quote") {
          navigate("/quote");
        } else {
          navigate("/orders");
        }
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}


function* logoutUser({ payload: { navigate } }) {
  try {
    localStorage.removeItem("authUser")
    yield put(clearUserPermissions())
    navigate("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

// function* socialLogin({ payload: { data, history, type } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const fireBaseBackend = getFirebaseBackend()
//       const response = yield call(
//         fireBaseBackend.socialLoginUser,
//         data,
//         type,
//       )
//       localStorage.setItem("authUser", JSON.stringify(response))
//       yield put(loginSuccess(response))
//     } else {
//       const response = yield call(postSocialLogin, data)
//       localStorage.setItem("authUser", JSON.stringify(response))
//       yield put(loginSuccess(response))
//     }
//     history.push("/dashboard")
//   } catch (error) {
//     yield put(apiError(error))
//   }
// }

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  // yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
